import styled from 'styled-components'

export const AnalysisAvgCostSoldValue = (props: {
  cost: React.ReactNode
  sold: React.ReactNode
}) => {
  return (
    <Root>
      <Cost>{props.cost}</Cost>&nbsp;/&nbsp;<Sold>{props.sold}</Sold>
    </Root>
  )
}
const Root = styled.div`
  color: var(--text-12);
  display: flex;
`
const Cost = styled.div`
  color: var(--up-9);
`
const Sold = styled.div`
  color: var(--down-9);
`
